/** The customer's "reduce motion" setting. Read at the moment of animating,
 *  so a change takes effect without a reload. */
export function prefersReducedMotion(): boolean {
  return typeof window !== 'undefined' && !!window.matchMedia?.('(prefers-reduced-motion: reduce)').matches
}

/**
 * Element.animate, or nothing: skipped under reduced motion and on a WebView
 * without the Web Animations API, so callers never have to check.
 */
export function play(
  element: Element | null | undefined,
  keyframes: Keyframe[],
  options: KeyframeAnimationOptions,
): Animation | null {
  if (!element || typeof element.animate !== 'function' || prefersReducedMotion()) return null
  return element.animate(keyframes, options)
}

/** The house easing: quick out of the gate, soft landing. */
export const EASE_OUT = 'cubic-bezier(0.22,0.61,0.36,1)'
export const EASE_IN_OUT = 'cubic-bezier(0.65,0,0.35,1)'
